import React from 'react';

const Title = ({ children }) => (
    <>
        <h5 className="o-title-page position-relative mb-5">{children}</h5>
    </>
);

export default Title;